import { CumulioDashboard } from '../models/dashboard.model';

export const setAuthorization = <T extends CumulioDashboard>(
  dashboardComponent: T,
  iframe: HTMLIFrameElement,
  key: string,
  token: string
): Promise<void> => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        action: 'setAuthorization',
        key,
        token,
        _version: dashboardComponent.VERSION,
      },
      '*'
    );
    return Promise.resolve();
  }

  return Promise.reject(new Error('Cannot retrieve contentWindow.'));
};
